'use strict';

var icons__AdjustIcon_svg = require('./icons/AdjustIcon.svg.js');
var icons__AffiliateIcon_svg = require('./icons/AffiliateIcon.svg.js');
var icons__AirplaneIcon_svg = require('./icons/AirplaneIcon.svg.js');
var icons__AlertBubbleIcon_svg = require('./icons/AlertBubbleIcon.svg.js');
var icons__AlertCircleIcon_svg = require('./icons/AlertCircleIcon.svg.js');
var icons__AlertDiamondIcon_svg = require('./icons/AlertDiamondIcon.svg.js');
var icons__AlertTriangleIcon_svg = require('./icons/AlertTriangleIcon.svg.js');
var icons__AppExtensionIcon_svg = require('./icons/AppExtensionIcon.svg.js');
var icons__AppsFilledIcon_svg = require('./icons/AppsFilledIcon.svg.js');
var icons__AppsIcon_svg = require('./icons/AppsIcon.svg.js');
var icons__ArchiveIcon_svg = require('./icons/ArchiveIcon.svg.js');
var icons__ArrowDiagonalIcon_svg = require('./icons/ArrowDiagonalIcon.svg.js');
var icons__ArrowDownIcon_svg = require('./icons/ArrowDownIcon.svg.js');
var icons__ArrowLeftIcon_svg = require('./icons/ArrowLeftIcon.svg.js');
var icons__ArrowRightIcon_svg = require('./icons/ArrowRightIcon.svg.js');
var icons__ArrowUpIcon_svg = require('./icons/ArrowUpIcon.svg.js');
var icons__ArrowsInHorizontalIcon_svg = require('./icons/ArrowsInHorizontalIcon.svg.js');
var icons__ArrowsOutHorizontalFilledIcon_svg = require('./icons/ArrowsOutHorizontalFilledIcon.svg.js');
var icons__ArrowsOutHorizontalIcon_svg = require('./icons/ArrowsOutHorizontalIcon.svg.js');
var icons__AttachmentFilledIcon_svg = require('./icons/AttachmentFilledIcon.svg.js');
var icons__AttachmentIcon_svg = require('./icons/AttachmentIcon.svg.js');
var icons__AutomationFilledIcon_svg = require('./icons/AutomationFilledIcon.svg.js');
var icons__AutomationIcon_svg = require('./icons/AutomationIcon.svg.js');
var icons__BackspaceIcon_svg = require('./icons/BackspaceIcon.svg.js');
var icons__BankFilledIcon_svg = require('./icons/BankFilledIcon.svg.js');
var icons__BankIcon_svg = require('./icons/BankIcon.svg.js');
var icons__BarcodeIcon_svg = require('./icons/BarcodeIcon.svg.js');
var icons__BillFilledIcon_svg = require('./icons/BillFilledIcon.svg.js');
var icons__BillIcon_svg = require('./icons/BillIcon.svg.js');
var icons__BlankFilledIcon_svg = require('./icons/BlankFilledIcon.svg.js');
var icons__BlankIcon_svg = require('./icons/BlankIcon.svg.js');
var icons__BlogIcon_svg = require('./icons/BlogIcon.svg.js');
var icons__BookIcon_svg = require('./icons/BookIcon.svg.js');
var icons__BookOpenIcon_svg = require('./icons/BookOpenIcon.svg.js');
var icons__BugIcon_svg = require('./icons/BugIcon.svg.js');
var icons__BulletIcon_svg = require('./icons/BulletIcon.svg.js');
var icons__ButtonIcon_svg = require('./icons/ButtonIcon.svg.js');
var icons__ButtonPressIcon_svg = require('./icons/ButtonPressIcon.svg.js');
var icons__CalculatorIcon_svg = require('./icons/CalculatorIcon.svg.js');
var icons__CalendarCheckIcon_svg = require('./icons/CalendarCheckIcon.svg.js');
var icons__CalendarIcon_svg = require('./icons/CalendarIcon.svg.js');
var icons__CalendarTimeIcon_svg = require('./icons/CalendarTimeIcon.svg.js');
var icons__CameraFlipIcon_svg = require('./icons/CameraFlipIcon.svg.js');
var icons__CameraIcon_svg = require('./icons/CameraIcon.svg.js');
var icons__CaretDownIcon_svg = require('./icons/CaretDownIcon.svg.js');
var icons__CaretUpIcon_svg = require('./icons/CaretUpIcon.svg.js');
var icons__CartAbandonedFilledIcon_svg = require('./icons/CartAbandonedFilledIcon.svg.js');
var icons__CartAbandonedIcon_svg = require('./icons/CartAbandonedIcon.svg.js');
var icons__CartDiscountIcon_svg = require('./icons/CartDiscountIcon.svg.js');
var icons__CartDownFilledIcon_svg = require('./icons/CartDownFilledIcon.svg.js');
var icons__CartDownIcon_svg = require('./icons/CartDownIcon.svg.js');
var icons__CartFilledIcon_svg = require('./icons/CartFilledIcon.svg.js');
var icons__CartIcon_svg = require('./icons/CartIcon.svg.js');
var icons__CartSaleIcon_svg = require('./icons/CartSaleIcon.svg.js');
var icons__CartUpIcon_svg = require('./icons/CartUpIcon.svg.js');
var icons__CashDollarFilledIcon_svg = require('./icons/CashDollarFilledIcon.svg.js');
var icons__CashDollarIcon_svg = require('./icons/CashDollarIcon.svg.js');
var icons__CashEuroIcon_svg = require('./icons/CashEuroIcon.svg.js');
var icons__CashPoundIcon_svg = require('./icons/CashPoundIcon.svg.js');
var icons__CashRupeeIcon_svg = require('./icons/CashRupeeIcon.svg.js');
var icons__CashYenIcon_svg = require('./icons/CashYenIcon.svg.js');
var icons__CategoriesIcon_svg = require('./icons/CategoriesIcon.svg.js');
var icons__ChannelsIcon_svg = require('./icons/ChannelsIcon.svg.js');
var icons__ChartCohortIcon_svg = require('./icons/ChartCohortIcon.svg.js');
var icons__ChartDonutIcon_svg = require('./icons/ChartDonutIcon.svg.js');
var icons__ChartFunnelIcon_svg = require('./icons/ChartFunnelIcon.svg.js');
var icons__ChartHistogramFirstIcon_svg = require('./icons/ChartHistogramFirstIcon.svg.js');
var icons__ChartHistogramFirstLastIcon_svg = require('./icons/ChartHistogramFirstLastIcon.svg.js');
var icons__ChartHistogramFlatIcon_svg = require('./icons/ChartHistogramFlatIcon.svg.js');
var icons__ChartHistogramFullIcon_svg = require('./icons/ChartHistogramFullIcon.svg.js');
var icons__ChartHistogramGrowthIcon_svg = require('./icons/ChartHistogramGrowthIcon.svg.js');
var icons__ChartHistogramLastIcon_svg = require('./icons/ChartHistogramLastIcon.svg.js');
var icons__ChartHistogramSecondLastIcon_svg = require('./icons/ChartHistogramSecondLastIcon.svg.js');
var icons__ChartHorizontalIcon_svg = require('./icons/ChartHorizontalIcon.svg.js');
var icons__ChartLineIcon_svg = require('./icons/ChartLineIcon.svg.js');
var icons__ChartPopularIcon_svg = require('./icons/ChartPopularIcon.svg.js');
var icons__ChartStackedIcon_svg = require('./icons/ChartStackedIcon.svg.js');
var icons__ChartVerticalFilledIcon_svg = require('./icons/ChartVerticalFilledIcon.svg.js');
var icons__ChartVerticalIcon_svg = require('./icons/ChartVerticalIcon.svg.js');
var icons__ChatIcon_svg = require('./icons/ChatIcon.svg.js');
var icons__ChatReferralIcon_svg = require('./icons/ChatReferralIcon.svg.js');
var icons__CheckCircleIcon_svg = require('./icons/CheckCircleIcon.svg.js');
var icons__CheckIcon_svg = require('./icons/CheckIcon.svg.js');
var icons__CheckSmallIcon_svg = require('./icons/CheckSmallIcon.svg.js');
var icons__CheckboxIcon_svg = require('./icons/CheckboxIcon.svg.js');
var icons__ChevronDownIcon_svg = require('./icons/ChevronDownIcon.svg.js');
var icons__ChevronLeftIcon_svg = require('./icons/ChevronLeftIcon.svg.js');
var icons__ChevronRightIcon_svg = require('./icons/ChevronRightIcon.svg.js');
var icons__ChevronUpIcon_svg = require('./icons/ChevronUpIcon.svg.js');
var icons__CircleChevronDownIcon_svg = require('./icons/CircleChevronDownIcon.svg.js');
var icons__CircleChevronLeftIcon_svg = require('./icons/CircleChevronLeftIcon.svg.js');
var icons__CircleChevronRightIcon_svg = require('./icons/CircleChevronRightIcon.svg.js');
var icons__CircleChevronUpIcon_svg = require('./icons/CircleChevronUpIcon.svg.js');
var icons__CircleDownIcon_svg = require('./icons/CircleDownIcon.svg.js');
var icons__CircleLeftIcon_svg = require('./icons/CircleLeftIcon.svg.js');
var icons__CircleRightIcon_svg = require('./icons/CircleRightIcon.svg.js');
var icons__CircleUpIcon_svg = require('./icons/CircleUpIcon.svg.js');
var icons__ClipboardCheckFilledIcon_svg = require('./icons/ClipboardCheckFilledIcon.svg.js');
var icons__ClipboardCheckIcon_svg = require('./icons/ClipboardCheckIcon.svg.js');
var icons__ClipboardChecklistIcon_svg = require('./icons/ClipboardChecklistIcon.svg.js');
var icons__ClipboardIcon_svg = require('./icons/ClipboardIcon.svg.js');
var icons__ClockIcon_svg = require('./icons/ClockIcon.svg.js');
var icons__CodeAddIcon_svg = require('./icons/CodeAddIcon.svg.js');
var icons__CodeIcon_svg = require('./icons/CodeIcon.svg.js');
var icons__CollectionFeaturedIcon_svg = require('./icons/CollectionFeaturedIcon.svg.js');
var icons__CollectionFilledIcon_svg = require('./icons/CollectionFilledIcon.svg.js');
var icons__CollectionIcon_svg = require('./icons/CollectionIcon.svg.js');
var icons__CollectionListIcon_svg = require('./icons/CollectionListIcon.svg.js');
var icons__CollectionReferenceIcon_svg = require('./icons/CollectionReferenceIcon.svg.js');
var icons__ColorIcon_svg = require('./icons/ColorIcon.svg.js');
var icons__ColorNoneIcon_svg = require('./icons/ColorNoneIcon.svg.js');
var icons__CompassIcon_svg = require('./icons/CompassIcon.svg.js');
var icons__ComposeIcon_svg = require('./icons/ComposeIcon.svg.js');
var icons__ConfettiIcon_svg = require('./icons/ConfettiIcon.svg.js');
var icons__ConnectIcon_svg = require('./icons/ConnectIcon.svg.js');
var icons__ContentFilledIcon_svg = require('./icons/ContentFilledIcon.svg.js');
var icons__ContentIcon_svg = require('./icons/ContentIcon.svg.js');
var icons__ContractFilledIcon_svg = require('./icons/ContractFilledIcon.svg.js');
var icons__ContractIcon_svg = require('./icons/ContractIcon.svg.js');
var icons__CornerPillIcon_svg = require('./icons/CornerPillIcon.svg.js');
var icons__CornerRoundIcon_svg = require('./icons/CornerRoundIcon.svg.js');
var icons__CornerSquareIcon_svg = require('./icons/CornerSquareIcon.svg.js');
var icons__CreditCardCancelIcon_svg = require('./icons/CreditCardCancelIcon.svg.js');
var icons__CreditCardIcon_svg = require('./icons/CreditCardIcon.svg.js');
var icons__CreditCardPercentIcon_svg = require('./icons/CreditCardPercentIcon.svg.js');
var icons__CreditCardReaderChipIcon_svg = require('./icons/CreditCardReaderChipIcon.svg.js');
var icons__CreditCardReaderIcon_svg = require('./icons/CreditCardReaderIcon.svg.js');
var icons__CreditCardReaderTapIcon_svg = require('./icons/CreditCardReaderTapIcon.svg.js');
var icons__CreditCardSecureIcon_svg = require('./icons/CreditCardSecureIcon.svg.js');
var icons__CreditCardTapChipIcon_svg = require('./icons/CreditCardTapChipIcon.svg.js');
var icons__CropIcon_svg = require('./icons/CropIcon.svg.js');
var icons__CurrencyConvertIcon_svg = require('./icons/CurrencyConvertIcon.svg.js');
var icons__CursorBannerIcon_svg = require('./icons/CursorBannerIcon.svg.js');
var icons__CursorFilledIcon_svg = require('./icons/CursorFilledIcon.svg.js');
var icons__CursorIcon_svg = require('./icons/CursorIcon.svg.js');
var icons__CursorOptionIcon_svg = require('./icons/CursorOptionIcon.svg.js');
var icons__DataPresentationIcon_svg = require('./icons/DataPresentationIcon.svg.js');
var icons__DataTableIcon_svg = require('./icons/DataTableIcon.svg.js');
var icons__DatabaseAddIcon_svg = require('./icons/DatabaseAddIcon.svg.js');
var icons__DatabaseConnectIcon_svg = require('./icons/DatabaseConnectIcon.svg.js');
var icons__DatabaseIcon_svg = require('./icons/DatabaseIcon.svg.js');
var icons__DeleteIcon_svg = require('./icons/DeleteIcon.svg.js');
var icons__DeliveryFilledIcon_svg = require('./icons/DeliveryFilledIcon.svg.js');
var icons__DeliveryIcon_svg = require('./icons/DeliveryIcon.svg.js');
var icons__DesktopIcon_svg = require('./icons/DesktopIcon.svg.js');
var icons__DisabledIcon_svg = require('./icons/DisabledIcon.svg.js');
var icons__DiscountCodeIcon_svg = require('./icons/DiscountCodeIcon.svg.js');
var icons__DiscountFilledIcon_svg = require('./icons/DiscountFilledIcon.svg.js');
var icons__DiscountIcon_svg = require('./icons/DiscountIcon.svg.js');
var icons__DnsSettingsIcon_svg = require('./icons/DnsSettingsIcon.svg.js');
var icons__DockFloatingIcon_svg = require('./icons/DockFloatingIcon.svg.js');
var icons__DockSideIcon_svg = require('./icons/DockSideIcon.svg.js');
var icons__DomainFilledIcon_svg = require('./icons/DomainFilledIcon.svg.js');
var icons__DomainIcon_svg = require('./icons/DomainIcon.svg.js');
var icons__DomainLandingPageIcon_svg = require('./icons/DomainLandingPageIcon.svg.js');
var icons__DomainNewIcon_svg = require('./icons/DomainNewIcon.svg.js');
var icons__DomainRedirectIcon_svg = require('./icons/DomainRedirectIcon.svg.js');
var icons__DragDropIcon_svg = require('./icons/DragDropIcon.svg.js');
var icons__DragHandleIcon_svg = require('./icons/DragHandleIcon.svg.js');
var icons__DuplicateIcon_svg = require('./icons/DuplicateIcon.svg.js');
var icons__EditIcon_svg = require('./icons/EditIcon.svg.js');
var icons__EmailFollowUpIcon_svg = require('./icons/EmailFollowUpIcon.svg.js');
var icons__EmailIcon_svg = require('./icons/EmailIcon.svg.js');
var icons__EmailNewsletterIcon_svg = require('./icons/EmailNewsletterIcon.svg.js');
var icons__EnterIcon_svg = require('./icons/EnterIcon.svg.js');
var icons__EnvelopeIcon_svg = require('./icons/EnvelopeIcon.svg.js');
var icons__EnvelopeSoftPackIcon_svg = require('./icons/EnvelopeSoftPackIcon.svg.js');
var icons__ExchangeIcon_svg = require('./icons/ExchangeIcon.svg.js');
var icons__ExitIcon_svg = require('./icons/ExitIcon.svg.js');
var icons__ExportIcon_svg = require('./icons/ExportIcon.svg.js');
var icons__ExternalIcon_svg = require('./icons/ExternalIcon.svg.js');
var icons__ExternalSmallIcon_svg = require('./icons/ExternalSmallIcon.svg.js');
var icons__EyeCheckMarkIcon_svg = require('./icons/EyeCheckMarkIcon.svg.js');
var icons__EyeDropperIcon_svg = require('./icons/EyeDropperIcon.svg.js');
var icons__EyeFirstIcon_svg = require('./icons/EyeFirstIcon.svg.js');
var icons__EyeglassesIcon_svg = require('./icons/EyeglassesIcon.svg.js');
var icons__FaviconIcon_svg = require('./icons/FaviconIcon.svg.js');
var icons__FileFilledIcon_svg = require('./icons/FileFilledIcon.svg.js');
var icons__FileIcon_svg = require('./icons/FileIcon.svg.js');
var icons__FilterIcon_svg = require('./icons/FilterIcon.svg.js');
var icons__FlagIcon_svg = require('./icons/FlagIcon.svg.js');
var icons__FlipHorizontalIcon_svg = require('./icons/FlipHorizontalIcon.svg.js');
var icons__FlipVerticalIcon_svg = require('./icons/FlipVerticalIcon.svg.js');
var icons__FlowerFilledIcon_svg = require('./icons/FlowerFilledIcon.svg.js');
var icons__FlowerIcon_svg = require('./icons/FlowerIcon.svg.js');
var icons__FolderAddIcon_svg = require('./icons/FolderAddIcon.svg.js');
var icons__FolderDownIcon_svg = require('./icons/FolderDownIcon.svg.js');
var icons__FolderIcon_svg = require('./icons/FolderIcon.svg.js');
var icons__FolderRemoveIcon_svg = require('./icons/FolderRemoveIcon.svg.js');
var icons__FolderUpIcon_svg = require('./icons/FolderUpIcon.svg.js');
var icons__FoodIcon_svg = require('./icons/FoodIcon.svg.js');
var icons__ForkliftIcon_svg = require('./icons/ForkliftIcon.svg.js');
var icons__FormsIcon_svg = require('./icons/FormsIcon.svg.js');
var icons__GamesIcon_svg = require('./icons/GamesIcon.svg.js');
var icons__GaugeIcon_svg = require('./icons/GaugeIcon.svg.js');
var icons__GiftCardFilledIcon_svg = require('./icons/GiftCardFilledIcon.svg.js');
var icons__GiftCardIcon_svg = require('./icons/GiftCardIcon.svg.js');
var icons__GlobeAsiaFilledIcon_svg = require('./icons/GlobeAsiaFilledIcon.svg.js');
var icons__GlobeAsiaIcon_svg = require('./icons/GlobeAsiaIcon.svg.js');
var icons__GlobeEUFilledIcon_svg = require('./icons/GlobeEUFilledIcon.svg.js');
var icons__GlobeEUIcon_svg = require('./icons/GlobeEUIcon.svg.js');
var icons__GlobeFilledIcon_svg = require('./icons/GlobeFilledIcon.svg.js');
var icons__GlobeIcon_svg = require('./icons/GlobeIcon.svg.js');
var icons__HashtagDecimalIcon_svg = require('./icons/HashtagDecimalIcon.svg.js');
var icons__HashtagIcon_svg = require('./icons/HashtagIcon.svg.js');
var icons__HeartIcon_svg = require('./icons/HeartIcon.svg.js');
var icons__HideIcon_svg = require('./icons/HideIcon.svg.js');
var icons__HomeFilledIcon_svg = require('./icons/HomeFilledIcon.svg.js');
var icons__HomeIcon_svg = require('./icons/HomeIcon.svg.js');
var icons__IconsFilledIcon_svg = require('./icons/IconsFilledIcon.svg.js');
var icons__IconsIcon_svg = require('./icons/IconsIcon.svg.js');
var icons__IdentityCardFilledIcon_svg = require('./icons/IdentityCardFilledIcon.svg.js');
var icons__IdentityCardIcon_svg = require('./icons/IdentityCardIcon.svg.js');
var icons__ImageAddIcon_svg = require('./icons/ImageAddIcon.svg.js');
var icons__ImageAltIcon_svg = require('./icons/ImageAltIcon.svg.js');
var icons__ImageExploreIcon_svg = require('./icons/ImageExploreIcon.svg.js');
var icons__ImageIcon_svg = require('./icons/ImageIcon.svg.js');
var icons__ImageMagicIcon_svg = require('./icons/ImageMagicIcon.svg.js');
var icons__ImageWithTextOverlayIcon_svg = require('./icons/ImageWithTextOverlayIcon.svg.js');
var icons__ImagesIcon_svg = require('./icons/ImagesIcon.svg.js');
var icons__ImportIcon_svg = require('./icons/ImportIcon.svg.js');
var icons__IncentiveIcon_svg = require('./icons/IncentiveIcon.svg.js');
var icons__IncomingIcon_svg = require('./icons/IncomingIcon.svg.js');
var icons__InfoIcon_svg = require('./icons/InfoIcon.svg.js');
var icons__InventoryFilledIcon_svg = require('./icons/InventoryFilledIcon.svg.js');
var icons__InventoryIcon_svg = require('./icons/InventoryIcon.svg.js');
var icons__InventoryUpdatedIcon_svg = require('./icons/InventoryUpdatedIcon.svg.js');
var icons__IqIcon_svg = require('./icons/IqIcon.svg.js');
var icons__KeyIcon_svg = require('./icons/KeyIcon.svg.js');
var icons__KeyboardHideIcon_svg = require('./icons/KeyboardHideIcon.svg.js');
var icons__KeyboardIcon_svg = require('./icons/KeyboardIcon.svg.js');
var icons__LabelPrinterIcon_svg = require('./icons/LabelPrinterIcon.svg.js');
var icons__LanguageFilledIcon_svg = require('./icons/LanguageFilledIcon.svg.js');
var icons__LanguageIcon_svg = require('./icons/LanguageIcon.svg.js');
var icons__LanguageTranslateIcon_svg = require('./icons/LanguageTranslateIcon.svg.js');
var icons__LayoutBlockIcon_svg = require('./icons/LayoutBlockIcon.svg.js');
var icons__LayoutBuyButtonHorizontalIcon_svg = require('./icons/LayoutBuyButtonHorizontalIcon.svg.js');
var icons__LayoutBuyButtonIcon_svg = require('./icons/LayoutBuyButtonIcon.svg.js');
var icons__LayoutBuyButtonVerticalIcon_svg = require('./icons/LayoutBuyButtonVerticalIcon.svg.js');
var icons__LayoutColumn1Icon_svg = require('./icons/LayoutColumn1Icon.svg.js');
var icons__LayoutColumns2Icon_svg = require('./icons/LayoutColumns2Icon.svg.js');
var icons__LayoutColumns3Icon_svg = require('./icons/LayoutColumns3Icon.svg.js');
var icons__LayoutFooterIcon_svg = require('./icons/LayoutFooterIcon.svg.js');
var icons__LayoutHeaderIcon_svg = require('./icons/LayoutHeaderIcon.svg.js');
var icons__LayoutLogoBlockIcon_svg = require('./icons/LayoutLogoBlockIcon.svg.js');
var icons__LayoutPopupIcon_svg = require('./icons/LayoutPopupIcon.svg.js');
var icons__LayoutRows2Icon_svg = require('./icons/LayoutRows2Icon.svg.js');
var icons__LayoutSectionIcon_svg = require('./icons/LayoutSectionIcon.svg.js');
var icons__LayoutSidebarLeftIcon_svg = require('./icons/LayoutSidebarLeftIcon.svg.js');
var icons__LayoutSidebarRightIcon_svg = require('./icons/LayoutSidebarRightIcon.svg.js');
var icons__LightbulbIcon_svg = require('./icons/LightbulbIcon.svg.js');
var icons__LinkIcon_svg = require('./icons/LinkIcon.svg.js');
var icons__ListBulletedFilledIcon_svg = require('./icons/ListBulletedFilledIcon.svg.js');
var icons__ListBulletedIcon_svg = require('./icons/ListBulletedIcon.svg.js');
var icons__ListNumberedIcon_svg = require('./icons/ListNumberedIcon.svg.js');
var icons__LiveFilledIcon_svg = require('./icons/LiveFilledIcon.svg.js');
var icons__LiveIcon_svg = require('./icons/LiveIcon.svg.js');
var icons__LocationFilledIcon_svg = require('./icons/LocationFilledIcon.svg.js');
var icons__LocationIcon_svg = require('./icons/LocationIcon.svg.js');
var icons__LocationNoneIcon_svg = require('./icons/LocationNoneIcon.svg.js');
var icons__LockFilledIcon_svg = require('./icons/LockFilledIcon.svg.js');
var icons__LockIcon_svg = require('./icons/LockIcon.svg.js');
var icons__LogoCriteoIcon_svg = require('./icons/LogoCriteoIcon.svg.js');
var icons__LogoFacebookIcon_svg = require('./icons/LogoFacebookIcon.svg.js');
var icons__LogoGoogleIcon_svg = require('./icons/LogoGoogleIcon.svg.js');
var icons__LogoInstagramIcon_svg = require('./icons/LogoInstagramIcon.svg.js');
var icons__LogoMetaIcon_svg = require('./icons/LogoMetaIcon.svg.js');
var icons__LogoPinterestIcon_svg = require('./icons/LogoPinterestIcon.svg.js');
var icons__LogoSnapchatIcon_svg = require('./icons/LogoSnapchatIcon.svg.js');
var icons__LogoTiktokIcon_svg = require('./icons/LogoTiktokIcon.svg.js');
var icons__LogoTumblrIcon_svg = require('./icons/LogoTumblrIcon.svg.js');
var icons__LogoTwitchIcon_svg = require('./icons/LogoTwitchIcon.svg.js');
var icons__LogoVimeoIcon_svg = require('./icons/LogoVimeoIcon.svg.js');
var icons__LogoXIcon_svg = require('./icons/LogoXIcon.svg.js');
var icons__LogoYoutubeIcon_svg = require('./icons/LogoYoutubeIcon.svg.js');
var icons__MagicIcon_svg = require('./icons/MagicIcon.svg.js');
var icons__MarketsEuroFilledIcon_svg = require('./icons/MarketsEuroFilledIcon.svg.js');
var icons__MarketsEuroIcon_svg = require('./icons/MarketsEuroIcon.svg.js');
var icons__MarketsFilledIcon_svg = require('./icons/MarketsFilledIcon.svg.js');
var icons__MarketsIcon_svg = require('./icons/MarketsIcon.svg.js');
var icons__MarketsRupeeFilledIcon_svg = require('./icons/MarketsRupeeFilledIcon.svg.js');
var icons__MarketsRupeeIcon_svg = require('./icons/MarketsRupeeIcon.svg.js');
var icons__MarketsYenFilledIcon_svg = require('./icons/MarketsYenFilledIcon.svg.js');
var icons__MarketsYenIcon_svg = require('./icons/MarketsYenIcon.svg.js');
var icons__MaximizeIcon_svg = require('./icons/MaximizeIcon.svg.js');
var icons__MeasurementSizeIcon_svg = require('./icons/MeasurementSizeIcon.svg.js');
var icons__MeasurementVolumeIcon_svg = require('./icons/MeasurementVolumeIcon.svg.js');
var icons__MeasurementWeightIcon_svg = require('./icons/MeasurementWeightIcon.svg.js');
var icons__MediaReceiverIcon_svg = require('./icons/MediaReceiverIcon.svg.js');
var icons__MegaphoneFilledIcon_svg = require('./icons/MegaphoneFilledIcon.svg.js');
var icons__MegaphoneIcon_svg = require('./icons/MegaphoneIcon.svg.js');
var icons__MentionIcon_svg = require('./icons/MentionIcon.svg.js');
var icons__MenuHorizontalIcon_svg = require('./icons/MenuHorizontalIcon.svg.js');
var icons__MenuIcon_svg = require('./icons/MenuIcon.svg.js');
var icons__MenuVerticalIcon_svg = require('./icons/MenuVerticalIcon.svg.js');
var icons__MergeIcon_svg = require('./icons/MergeIcon.svg.js');
var icons__MetafieldsFilledIcon_svg = require('./icons/MetafieldsFilledIcon.svg.js');
var icons__MetafieldsIcon_svg = require('./icons/MetafieldsIcon.svg.js');
var icons__MetaobjectFilledIcon_svg = require('./icons/MetaobjectFilledIcon.svg.js');
var icons__MetaobjectIcon_svg = require('./icons/MetaobjectIcon.svg.js');
var icons__MetaobjectListIcon_svg = require('./icons/MetaobjectListIcon.svg.js');
var icons__MetaobjectReferenceIcon_svg = require('./icons/MetaobjectReferenceIcon.svg.js');
var icons__MicrophoneIcon_svg = require('./icons/MicrophoneIcon.svg.js');
var icons__MinimizeIcon_svg = require('./icons/MinimizeIcon.svg.js');
var icons__MinusCircleIcon_svg = require('./icons/MinusCircleIcon.svg.js');
var icons__MinusIcon_svg = require('./icons/MinusIcon.svg.js');
var icons__MobileIcon_svg = require('./icons/MobileIcon.svg.js');
var icons__MoneyFilledIcon_svg = require('./icons/MoneyFilledIcon.svg.js');
var icons__MoneyIcon_svg = require('./icons/MoneyIcon.svg.js');
var icons__MoneyNoneIcon_svg = require('./icons/MoneyNoneIcon.svg.js');
var icons__MoonIcon_svg = require('./icons/MoonIcon.svg.js');
var icons__NatureIcon_svg = require('./icons/NatureIcon.svg.js');
var icons__NoteAddIcon_svg = require('./icons/NoteAddIcon.svg.js');
var icons__NoteIcon_svg = require('./icons/NoteIcon.svg.js');
var icons__NotificationFilledIcon_svg = require('./icons/NotificationFilledIcon.svg.js');
var icons__NotificationIcon_svg = require('./icons/NotificationIcon.svg.js');
var icons__OrderDraftFilledIcon_svg = require('./icons/OrderDraftFilledIcon.svg.js');
var icons__OrderDraftIcon_svg = require('./icons/OrderDraftIcon.svg.js');
var icons__OrderFilledIcon_svg = require('./icons/OrderFilledIcon.svg.js');
var icons__OrderFirstIcon_svg = require('./icons/OrderFirstIcon.svg.js');
var icons__OrderFulfilledIcon_svg = require('./icons/OrderFulfilledIcon.svg.js');
var icons__OrderIcon_svg = require('./icons/OrderIcon.svg.js');
var icons__OrderRepeatIcon_svg = require('./icons/OrderRepeatIcon.svg.js');
var icons__OrderUnfulfilledIcon_svg = require('./icons/OrderUnfulfilledIcon.svg.js');
var icons__OrdersStatusIcon_svg = require('./icons/OrdersStatusIcon.svg.js');
var icons__OrganizationIcon_svg = require('./icons/OrganizationIcon.svg.js');
var icons__OutdentIcon_svg = require('./icons/OutdentIcon.svg.js');
var icons__OutgoingIcon_svg = require('./icons/OutgoingIcon.svg.js');
var icons__PackageFilledIcon_svg = require('./icons/PackageFilledIcon.svg.js');
var icons__PackageFulfilledIcon_svg = require('./icons/PackageFulfilledIcon.svg.js');
var icons__PackageIcon_svg = require('./icons/PackageIcon.svg.js');
var icons__PackageOnHoldIcon_svg = require('./icons/PackageOnHoldIcon.svg.js');
var icons__PackageReturnedIcon_svg = require('./icons/PackageReturnedIcon.svg.js');
var icons__PageAddIcon_svg = require('./icons/PageAddIcon.svg.js');
var icons__PageAttachmentIcon_svg = require('./icons/PageAttachmentIcon.svg.js');
var icons__PageClockFilledIcon_svg = require('./icons/PageClockFilledIcon.svg.js');
var icons__PageClockIcon_svg = require('./icons/PageClockIcon.svg.js');
var icons__PageDownIcon_svg = require('./icons/PageDownIcon.svg.js');
var icons__PageHeartIcon_svg = require('./icons/PageHeartIcon.svg.js');
var icons__PageIcon_svg = require('./icons/PageIcon.svg.js');
var icons__PageReferenceIcon_svg = require('./icons/PageReferenceIcon.svg.js');
var icons__PageRemoveIcon_svg = require('./icons/PageRemoveIcon.svg.js');
var icons__PageUpIcon_svg = require('./icons/PageUpIcon.svg.js');
var icons__PaginationEndIcon_svg = require('./icons/PaginationEndIcon.svg.js');
var icons__PaginationStartIcon_svg = require('./icons/PaginationStartIcon.svg.js');
var icons__PaintBrushFlatIcon_svg = require('./icons/PaintBrushFlatIcon.svg.js');
var icons__PaintBrushRoundIcon_svg = require('./icons/PaintBrushRoundIcon.svg.js');
var icons__PaperCheckIcon_svg = require('./icons/PaperCheckIcon.svg.js');
var icons__PasskeyFilledIcon_svg = require('./icons/PasskeyFilledIcon.svg.js');
var icons__PasskeyIcon_svg = require('./icons/PasskeyIcon.svg.js');
var icons__PauseCircleIcon_svg = require('./icons/PauseCircleIcon.svg.js');
var icons__PaymentCaptureIcon_svg = require('./icons/PaymentCaptureIcon.svg.js');
var icons__PaymentFilledIcon_svg = require('./icons/PaymentFilledIcon.svg.js');
var icons__PaymentIcon_svg = require('./icons/PaymentIcon.svg.js');
var icons__PersonAddIcon_svg = require('./icons/PersonAddIcon.svg.js');
var icons__PersonExitIcon_svg = require('./icons/PersonExitIcon.svg.js');
var icons__PersonFilledIcon_svg = require('./icons/PersonFilledIcon.svg.js');
var icons__PersonIcon_svg = require('./icons/PersonIcon.svg.js');
var icons__PersonLockFilledIcon_svg = require('./icons/PersonLockFilledIcon.svg.js');
var icons__PersonLockIcon_svg = require('./icons/PersonLockIcon.svg.js');
var icons__PersonRemoveIcon_svg = require('./icons/PersonRemoveIcon.svg.js');
var icons__PersonSegmentIcon_svg = require('./icons/PersonSegmentIcon.svg.js');
var icons__PersonalizedTextIcon_svg = require('./icons/PersonalizedTextIcon.svg.js');
var icons__PhoneIcon_svg = require('./icons/PhoneIcon.svg.js');
var icons__PhoneInIcon_svg = require('./icons/PhoneInIcon.svg.js');
var icons__PhoneOutIcon_svg = require('./icons/PhoneOutIcon.svg.js');
var icons__PinFilledIcon_svg = require('./icons/PinFilledIcon.svg.js');
var icons__PinIcon_svg = require('./icons/PinIcon.svg.js');
var icons__PlanFilledIcon_svg = require('./icons/PlanFilledIcon.svg.js');
var icons__PlanIcon_svg = require('./icons/PlanIcon.svg.js');
var icons__PlayCircleIcon_svg = require('./icons/PlayCircleIcon.svg.js');
var icons__PlayIcon_svg = require('./icons/PlayIcon.svg.js');
var icons__PlusCircleIcon_svg = require('./icons/PlusCircleIcon.svg.js');
var icons__PlusIcon_svg = require('./icons/PlusIcon.svg.js');
var icons__PointOfSaleIcon_svg = require('./icons/PointOfSaleIcon.svg.js');
var icons__PriceListFilledIcon_svg = require('./icons/PriceListFilledIcon.svg.js');
var icons__PriceListIcon_svg = require('./icons/PriceListIcon.svg.js');
var icons__PrintIcon_svg = require('./icons/PrintIcon.svg.js');
var icons__ProductAddIcon_svg = require('./icons/ProductAddIcon.svg.js');
var icons__ProductCostIcon_svg = require('./icons/ProductCostIcon.svg.js');
var icons__ProductFilledIcon_svg = require('./icons/ProductFilledIcon.svg.js');
var icons__ProductIcon_svg = require('./icons/ProductIcon.svg.js');
var icons__ProductListIcon_svg = require('./icons/ProductListIcon.svg.js');
var icons__ProductReferenceIcon_svg = require('./icons/ProductReferenceIcon.svg.js');
var icons__ProductRemoveIcon_svg = require('./icons/ProductRemoveIcon.svg.js');
var icons__ProductReturnIcon_svg = require('./icons/ProductReturnIcon.svg.js');
var icons__ProfileIcon_svg = require('./icons/ProfileIcon.svg.js');
var icons__QuestionCircleIcon_svg = require('./icons/QuestionCircleIcon.svg.js');
var icons__ReceiptDollarFilledIcon_svg = require('./icons/ReceiptDollarFilledIcon.svg.js');
var icons__ReceiptDollarIcon_svg = require('./icons/ReceiptDollarIcon.svg.js');
var icons__ReceiptEuroFilledIcon_svg = require('./icons/ReceiptEuroFilledIcon.svg.js');
var icons__ReceiptEuroIcon_svg = require('./icons/ReceiptEuroIcon.svg.js');
var icons__ReceiptIcon_svg = require('./icons/ReceiptIcon.svg.js');
var icons__ReceiptPaidIcon_svg = require('./icons/ReceiptPaidIcon.svg.js');
var icons__ReceiptPoundFilledIcon_svg = require('./icons/ReceiptPoundFilledIcon.svg.js');
var icons__ReceiptPoundIcon_svg = require('./icons/ReceiptPoundIcon.svg.js');
var icons__ReceiptRefundIcon_svg = require('./icons/ReceiptRefundIcon.svg.js');
var icons__ReceiptRupeeFilledIcon_svg = require('./icons/ReceiptRupeeFilledIcon.svg.js');
var icons__ReceiptRupeeIcon_svg = require('./icons/ReceiptRupeeIcon.svg.js');
var icons__ReceiptYenFilledIcon_svg = require('./icons/ReceiptYenFilledIcon.svg.js');
var icons__ReceiptYenIcon_svg = require('./icons/ReceiptYenIcon.svg.js');
var icons__RedoIcon_svg = require('./icons/RedoIcon.svg.js');
var icons__ReferralCodeIcon_svg = require('./icons/ReferralCodeIcon.svg.js');
var icons__RefreshIcon_svg = require('./icons/RefreshIcon.svg.js');
var icons__RemoveBackgroundIcon_svg = require('./icons/RemoveBackgroundIcon.svg.js');
var icons__ReplaceIcon_svg = require('./icons/ReplaceIcon.svg.js');
var icons__ReplayIcon_svg = require('./icons/ReplayIcon.svg.js');
var icons__ResetIcon_svg = require('./icons/ResetIcon.svg.js');
var icons__ReturnIcon_svg = require('./icons/ReturnIcon.svg.js');
var icons__RewardIcon_svg = require('./icons/RewardIcon.svg.js');
var icons__RotateLeftIcon_svg = require('./icons/RotateLeftIcon.svg.js');
var icons__RotateRightIcon_svg = require('./icons/RotateRightIcon.svg.js');
var icons__SandboxIcon_svg = require('./icons/SandboxIcon.svg.js');
var icons__SaveIcon_svg = require('./icons/SaveIcon.svg.js');
var icons__SearchIcon_svg = require('./icons/SearchIcon.svg.js');
var icons__SearchListIcon_svg = require('./icons/SearchListIcon.svg.js');
var icons__SearchRecentIcon_svg = require('./icons/SearchRecentIcon.svg.js');
var icons__SearchResourceIcon_svg = require('./icons/SearchResourceIcon.svg.js');
var icons__SelectIcon_svg = require('./icons/SelectIcon.svg.js');
var icons__SendIcon_svg = require('./icons/SendIcon.svg.js');
var icons__SettingsFilledIcon_svg = require('./icons/SettingsFilledIcon.svg.js');
var icons__SettingsIcon_svg = require('./icons/SettingsIcon.svg.js');
var icons__ShareIcon_svg = require('./icons/ShareIcon.svg.js');
var icons__ShieldCheckMarkIcon_svg = require('./icons/ShieldCheckMarkIcon.svg.js');
var icons__ShieldNoneIcon_svg = require('./icons/ShieldNoneIcon.svg.js');
var icons__ShieldPendingIcon_svg = require('./icons/ShieldPendingIcon.svg.js');
var icons__ShieldPersonIcon_svg = require('./icons/ShieldPersonIcon.svg.js');
var icons__ShippingLabelFilledIcon_svg = require('./icons/ShippingLabelFilledIcon.svg.js');
var icons__ShippingLabelIcon_svg = require('./icons/ShippingLabelIcon.svg.js');
var icons__ShopcodesIcon_svg = require('./icons/ShopcodesIcon.svg.js');
var icons__SidekickIcon_svg = require('./icons/SidekickIcon.svg.js');
var icons__SkeletonIcon_svg = require('./icons/SkeletonIcon.svg.js');
var icons__SlideshowIcon_svg = require('./icons/SlideshowIcon.svg.js');
var icons__SmileyHappyIcon_svg = require('./icons/SmileyHappyIcon.svg.js');
var icons__SmileyJoyIcon_svg = require('./icons/SmileyJoyIcon.svg.js');
var icons__SmileyNeutralIcon_svg = require('./icons/SmileyNeutralIcon.svg.js');
var icons__SmileySadIcon_svg = require('./icons/SmileySadIcon.svg.js');
var icons__SocialAdIcon_svg = require('./icons/SocialAdIcon.svg.js');
var icons__SocialPostIcon_svg = require('./icons/SocialPostIcon.svg.js');
var icons__SortAscendingIcon_svg = require('./icons/SortAscendingIcon.svg.js');
var icons__SortDescendingIcon_svg = require('./icons/SortDescendingIcon.svg.js');
var icons__SortIcon_svg = require('./icons/SortIcon.svg.js');
var icons__SoundIcon_svg = require('./icons/SoundIcon.svg.js');
var icons__SportsIcon_svg = require('./icons/SportsIcon.svg.js');
var icons__StarFilledIcon_svg = require('./icons/StarFilledIcon.svg.js');
var icons__StarIcon_svg = require('./icons/StarIcon.svg.js');
var icons__StatusActiveIcon_svg = require('./icons/StatusActiveIcon.svg.js');
var icons__StatusIcon_svg = require('./icons/StatusIcon.svg.js');
var icons__StopCircleIcon_svg = require('./icons/StopCircleIcon.svg.js');
var icons__StoreFilledIcon_svg = require('./icons/StoreFilledIcon.svg.js');
var icons__StoreIcon_svg = require('./icons/StoreIcon.svg.js');
var icons__StoreImportIcon_svg = require('./icons/StoreImportIcon.svg.js');
var icons__StoreManagedIcon_svg = require('./icons/StoreManagedIcon.svg.js');
var icons__StoreOnlineIcon_svg = require('./icons/StoreOnlineIcon.svg.js');
var icons__SunIcon_svg = require('./icons/SunIcon.svg.js');
var icons__TabletIcon_svg = require('./icons/TabletIcon.svg.js');
var icons__TargetFilledIcon_svg = require('./icons/TargetFilledIcon.svg.js');
var icons__TargetIcon_svg = require('./icons/TargetIcon.svg.js');
var icons__TaxFilledIcon_svg = require('./icons/TaxFilledIcon.svg.js');
var icons__TaxIcon_svg = require('./icons/TaxIcon.svg.js');
var icons__TeamIcon_svg = require('./icons/TeamIcon.svg.js');
var icons__TextAlignCenterIcon_svg = require('./icons/TextAlignCenterIcon.svg.js');
var icons__TextAlignLeftIcon_svg = require('./icons/TextAlignLeftIcon.svg.js');
var icons__TextAlignRightIcon_svg = require('./icons/TextAlignRightIcon.svg.js');
var icons__TextBlockIcon_svg = require('./icons/TextBlockIcon.svg.js');
var icons__TextBoldIcon_svg = require('./icons/TextBoldIcon.svg.js');
var icons__TextColorIcon_svg = require('./icons/TextColorIcon.svg.js');
var icons__TextFontIcon_svg = require('./icons/TextFontIcon.svg.js');
var icons__TextFontListIcon_svg = require('./icons/TextFontListIcon.svg.js');
var icons__TextGrammarIcon_svg = require('./icons/TextGrammarIcon.svg.js');
var icons__TextIcon_svg = require('./icons/TextIcon.svg.js');
var icons__TextInColumnsIcon_svg = require('./icons/TextInColumnsIcon.svg.js');
var icons__TextInRowsFilledIcon_svg = require('./icons/TextInRowsFilledIcon.svg.js');
var icons__TextInRowsIcon_svg = require('./icons/TextInRowsIcon.svg.js');
var icons__TextIndentIcon_svg = require('./icons/TextIndentIcon.svg.js');
var icons__TextItalicIcon_svg = require('./icons/TextItalicIcon.svg.js');
var icons__TextQuoteIcon_svg = require('./icons/TextQuoteIcon.svg.js');
var icons__TextTitleIcon_svg = require('./icons/TextTitleIcon.svg.js');
var icons__TextUnderlineIcon_svg = require('./icons/TextUnderlineIcon.svg.js');
var icons__TextWithImageIcon_svg = require('./icons/TextWithImageIcon.svg.js');
var icons__ThemeEditIcon_svg = require('./icons/ThemeEditIcon.svg.js');
var icons__ThemeIcon_svg = require('./icons/ThemeIcon.svg.js');
var icons__ThemeStoreIcon_svg = require('./icons/ThemeStoreIcon.svg.js');
var icons__ThemeTemplateIcon_svg = require('./icons/ThemeTemplateIcon.svg.js');
var icons__ThumbsDownIcon_svg = require('./icons/ThumbsDownIcon.svg.js');
var icons__ThumbsUpIcon_svg = require('./icons/ThumbsUpIcon.svg.js');
var icons__TipJarIcon_svg = require('./icons/TipJarIcon.svg.js');
var icons__ToggleOffIcon_svg = require('./icons/ToggleOffIcon.svg.js');
var icons__ToggleOnIcon_svg = require('./icons/ToggleOnIcon.svg.js');
var icons__TransactionFeeDollarIcon_svg = require('./icons/TransactionFeeDollarIcon.svg.js');
var icons__TransactionFeeEuroIcon_svg = require('./icons/TransactionFeeEuroIcon.svg.js');
var icons__TransactionFeePoundIcon_svg = require('./icons/TransactionFeePoundIcon.svg.js');
var icons__TransactionFeeRupeeIcon_svg = require('./icons/TransactionFeeRupeeIcon.svg.js');
var icons__TransactionFeeYenIcon_svg = require('./icons/TransactionFeeYenIcon.svg.js');
var icons__TransactionIcon_svg = require('./icons/TransactionIcon.svg.js');
var icons__TransferIcon_svg = require('./icons/TransferIcon.svg.js');
var icons__TransferInIcon_svg = require('./icons/TransferInIcon.svg.js');
var icons__TransferInternalIcon_svg = require('./icons/TransferInternalIcon.svg.js');
var icons__TransferOutIcon_svg = require('./icons/TransferOutIcon.svg.js');
var icons__UndoIcon_svg = require('./icons/UndoIcon.svg.js');
var icons__UnknownDeviceIcon_svg = require('./icons/UnknownDeviceIcon.svg.js');
var icons__UploadIcon_svg = require('./icons/UploadIcon.svg.js');
var icons__VariantIcon_svg = require('./icons/VariantIcon.svg.js');
var icons__ViewIcon_svg = require('./icons/ViewIcon.svg.js');
var icons__ViewportNarrowIcon_svg = require('./icons/ViewportNarrowIcon.svg.js');
var icons__ViewportShortIcon_svg = require('./icons/ViewportShortIcon.svg.js');
var icons__ViewportTallIcon_svg = require('./icons/ViewportTallIcon.svg.js');
var icons__ViewportWideIcon_svg = require('./icons/ViewportWideIcon.svg.js');
var icons__WalletFilledIcon_svg = require('./icons/WalletFilledIcon.svg.js');
var icons__WalletIcon_svg = require('./icons/WalletIcon.svg.js');
var icons__WandIcon_svg = require('./icons/WandIcon.svg.js');
var icons__WatchIcon_svg = require('./icons/WatchIcon.svg.js');
var icons__WifiIcon_svg = require('./icons/WifiIcon.svg.js');
var icons__WorkFilledIcon_svg = require('./icons/WorkFilledIcon.svg.js');
var icons__WorkIcon_svg = require('./icons/WorkIcon.svg.js');
var icons__WrenchIcon_svg = require('./icons/WrenchIcon.svg.js');
var icons__XCircleIcon_svg = require('./icons/XCircleIcon.svg.js');
var icons__XIcon_svg = require('./icons/XIcon.svg.js');
var icons__XSmallIcon_svg = require('./icons/XSmallIcon.svg.js');
require('react');



exports.AdjustIcon = icons__AdjustIcon_svg.SvgAdjustIcon;
exports.AffiliateIcon = icons__AffiliateIcon_svg.SvgAffiliateIcon;
exports.AirplaneIcon = icons__AirplaneIcon_svg.SvgAirplaneIcon;
exports.AlertBubbleIcon = icons__AlertBubbleIcon_svg.SvgAlertBubbleIcon;
exports.AlertCircleIcon = icons__AlertCircleIcon_svg.SvgAlertCircleIcon;
exports.AlertDiamondIcon = icons__AlertDiamondIcon_svg.SvgAlertDiamondIcon;
exports.AlertTriangleIcon = icons__AlertTriangleIcon_svg.SvgAlertTriangleIcon;
exports.AppExtensionIcon = icons__AppExtensionIcon_svg.SvgAppExtensionIcon;
exports.AppsFilledIcon = icons__AppsFilledIcon_svg.SvgAppsFilledIcon;
exports.AppsIcon = icons__AppsIcon_svg.SvgAppsIcon;
exports.ArchiveIcon = icons__ArchiveIcon_svg.SvgArchiveIcon;
exports.ArrowDiagonalIcon = icons__ArrowDiagonalIcon_svg.SvgArrowDiagonalIcon;
exports.ArrowDownIcon = icons__ArrowDownIcon_svg.SvgArrowDownIcon;
exports.ArrowLeftIcon = icons__ArrowLeftIcon_svg.SvgArrowLeftIcon;
exports.ArrowRightIcon = icons__ArrowRightIcon_svg.SvgArrowRightIcon;
exports.ArrowUpIcon = icons__ArrowUpIcon_svg.SvgArrowUpIcon;
exports.ArrowsInHorizontalIcon = icons__ArrowsInHorizontalIcon_svg.SvgArrowsInHorizontalIcon;
exports.ArrowsOutHorizontalFilledIcon = icons__ArrowsOutHorizontalFilledIcon_svg.SvgArrowsOutHorizontalFilledIcon;
exports.ArrowsOutHorizontalIcon = icons__ArrowsOutHorizontalIcon_svg.SvgArrowsOutHorizontalIcon;
exports.AttachmentFilledIcon = icons__AttachmentFilledIcon_svg.SvgAttachmentFilledIcon;
exports.AttachmentIcon = icons__AttachmentIcon_svg.SvgAttachmentIcon;
exports.AutomationFilledIcon = icons__AutomationFilledIcon_svg.SvgAutomationFilledIcon;
exports.AutomationIcon = icons__AutomationIcon_svg.SvgAutomationIcon;
exports.BackspaceIcon = icons__BackspaceIcon_svg.SvgBackspaceIcon;
exports.BankFilledIcon = icons__BankFilledIcon_svg.SvgBankFilledIcon;
exports.BankIcon = icons__BankIcon_svg.SvgBankIcon;
exports.BarcodeIcon = icons__BarcodeIcon_svg.SvgBarcodeIcon;
exports.BillFilledIcon = icons__BillFilledIcon_svg.SvgBillFilledIcon;
exports.BillIcon = icons__BillIcon_svg.SvgBillIcon;
exports.BlankFilledIcon = icons__BlankFilledIcon_svg.SvgBlankFilledIcon;
exports.BlankIcon = icons__BlankIcon_svg.SvgBlankIcon;
exports.BlogIcon = icons__BlogIcon_svg.SvgBlogIcon;
exports.BookIcon = icons__BookIcon_svg.SvgBookIcon;
exports.BookOpenIcon = icons__BookOpenIcon_svg.SvgBookOpenIcon;
exports.BugIcon = icons__BugIcon_svg.SvgBugIcon;
exports.BulletIcon = icons__BulletIcon_svg.SvgBulletIcon;
exports.ButtonIcon = icons__ButtonIcon_svg.SvgButtonIcon;
exports.ButtonPressIcon = icons__ButtonPressIcon_svg.SvgButtonPressIcon;
exports.CalculatorIcon = icons__CalculatorIcon_svg.SvgCalculatorIcon;
exports.CalendarCheckIcon = icons__CalendarCheckIcon_svg.SvgCalendarCheckIcon;
exports.CalendarIcon = icons__CalendarIcon_svg.SvgCalendarIcon;
exports.CalendarTimeIcon = icons__CalendarTimeIcon_svg.SvgCalendarTimeIcon;
exports.CameraFlipIcon = icons__CameraFlipIcon_svg.SvgCameraFlipIcon;
exports.CameraIcon = icons__CameraIcon_svg.SvgCameraIcon;
exports.CaretDownIcon = icons__CaretDownIcon_svg.SvgCaretDownIcon;
exports.CaretUpIcon = icons__CaretUpIcon_svg.SvgCaretUpIcon;
exports.CartAbandonedFilledIcon = icons__CartAbandonedFilledIcon_svg.SvgCartAbandonedFilledIcon;
exports.CartAbandonedIcon = icons__CartAbandonedIcon_svg.SvgCartAbandonedIcon;
exports.CartDiscountIcon = icons__CartDiscountIcon_svg.SvgCartDiscountIcon;
exports.CartDownFilledIcon = icons__CartDownFilledIcon_svg.SvgCartDownFilledIcon;
exports.CartDownIcon = icons__CartDownIcon_svg.SvgCartDownIcon;
exports.CartFilledIcon = icons__CartFilledIcon_svg.SvgCartFilledIcon;
exports.CartIcon = icons__CartIcon_svg.SvgCartIcon;
exports.CartSaleIcon = icons__CartSaleIcon_svg.SvgCartSaleIcon;
exports.CartUpIcon = icons__CartUpIcon_svg.SvgCartUpIcon;
exports.CashDollarFilledIcon = icons__CashDollarFilledIcon_svg.SvgCashDollarFilledIcon;
exports.CashDollarIcon = icons__CashDollarIcon_svg.SvgCashDollarIcon;
exports.CashEuroIcon = icons__CashEuroIcon_svg.SvgCashEuroIcon;
exports.CashPoundIcon = icons__CashPoundIcon_svg.SvgCashPoundIcon;
exports.CashRupeeIcon = icons__CashRupeeIcon_svg.SvgCashRupeeIcon;
exports.CashYenIcon = icons__CashYenIcon_svg.SvgCashYenIcon;
exports.CategoriesIcon = icons__CategoriesIcon_svg.SvgCategoriesIcon;
exports.ChannelsIcon = icons__ChannelsIcon_svg.SvgChannelsIcon;
exports.ChartCohortIcon = icons__ChartCohortIcon_svg.SvgChartCohortIcon;
exports.ChartDonutIcon = icons__ChartDonutIcon_svg.SvgChartDonutIcon;
exports.ChartFunnelIcon = icons__ChartFunnelIcon_svg.SvgChartFunnelIcon;
exports.ChartHistogramFirstIcon = icons__ChartHistogramFirstIcon_svg.SvgChartHistogramFirstIcon;
exports.ChartHistogramFirstLastIcon = icons__ChartHistogramFirstLastIcon_svg.SvgChartHistogramFirstLastIcon;
exports.ChartHistogramFlatIcon = icons__ChartHistogramFlatIcon_svg.SvgChartHistogramFlatIcon;
exports.ChartHistogramFullIcon = icons__ChartHistogramFullIcon_svg.SvgChartHistogramFullIcon;
exports.ChartHistogramGrowthIcon = icons__ChartHistogramGrowthIcon_svg.SvgChartHistogramGrowthIcon;
exports.ChartHistogramLastIcon = icons__ChartHistogramLastIcon_svg.SvgChartHistogramLastIcon;
exports.ChartHistogramSecondLastIcon = icons__ChartHistogramSecondLastIcon_svg.SvgChartHistogramSecondLastIcon;
exports.ChartHorizontalIcon = icons__ChartHorizontalIcon_svg.SvgChartHorizontalIcon;
exports.ChartLineIcon = icons__ChartLineIcon_svg.SvgChartLineIcon;
exports.ChartPopularIcon = icons__ChartPopularIcon_svg.SvgChartPopularIcon;
exports.ChartStackedIcon = icons__ChartStackedIcon_svg.SvgChartStackedIcon;
exports.ChartVerticalFilledIcon = icons__ChartVerticalFilledIcon_svg.SvgChartVerticalFilledIcon;
exports.ChartVerticalIcon = icons__ChartVerticalIcon_svg.SvgChartVerticalIcon;
exports.ChatIcon = icons__ChatIcon_svg.SvgChatIcon;
exports.ChatReferralIcon = icons__ChatReferralIcon_svg.SvgChatReferralIcon;
exports.CheckCircleIcon = icons__CheckCircleIcon_svg.SvgCheckCircleIcon;
exports.CheckIcon = icons__CheckIcon_svg.SvgCheckIcon;
exports.CheckSmallIcon = icons__CheckSmallIcon_svg.SvgCheckSmallIcon;
exports.CheckboxIcon = icons__CheckboxIcon_svg.SvgCheckboxIcon;
exports.ChevronDownIcon = icons__ChevronDownIcon_svg.SvgChevronDownIcon;
exports.ChevronLeftIcon = icons__ChevronLeftIcon_svg.SvgChevronLeftIcon;
exports.ChevronRightIcon = icons__ChevronRightIcon_svg.SvgChevronRightIcon;
exports.ChevronUpIcon = icons__ChevronUpIcon_svg.SvgChevronUpIcon;
exports.CircleChevronDownIcon = icons__CircleChevronDownIcon_svg.SvgCircleChevronDownIcon;
exports.CircleChevronLeftIcon = icons__CircleChevronLeftIcon_svg.SvgCircleChevronLeftIcon;
exports.CircleChevronRightIcon = icons__CircleChevronRightIcon_svg.SvgCircleChevronRightIcon;
exports.CircleChevronUpIcon = icons__CircleChevronUpIcon_svg.SvgCircleChevronUpIcon;
exports.CircleDownIcon = icons__CircleDownIcon_svg.SvgCircleDownIcon;
exports.CircleLeftIcon = icons__CircleLeftIcon_svg.SvgCircleLeftIcon;
exports.CircleRightIcon = icons__CircleRightIcon_svg.SvgCircleRightIcon;
exports.CircleUpIcon = icons__CircleUpIcon_svg.SvgCircleUpIcon;
exports.ClipboardCheckFilledIcon = icons__ClipboardCheckFilledIcon_svg.SvgClipboardCheckFilledIcon;
exports.ClipboardCheckIcon = icons__ClipboardCheckIcon_svg.SvgClipboardCheckIcon;
exports.ClipboardChecklistIcon = icons__ClipboardChecklistIcon_svg.SvgClipboardChecklistIcon;
exports.ClipboardIcon = icons__ClipboardIcon_svg.SvgClipboardIcon;
exports.ClockIcon = icons__ClockIcon_svg.SvgClockIcon;
exports.CodeAddIcon = icons__CodeAddIcon_svg.SvgCodeAddIcon;
exports.CodeIcon = icons__CodeIcon_svg.SvgCodeIcon;
exports.CollectionFeaturedIcon = icons__CollectionFeaturedIcon_svg.SvgCollectionFeaturedIcon;
exports.CollectionFilledIcon = icons__CollectionFilledIcon_svg.SvgCollectionFilledIcon;
exports.CollectionIcon = icons__CollectionIcon_svg.SvgCollectionIcon;
exports.CollectionListIcon = icons__CollectionListIcon_svg.SvgCollectionListIcon;
exports.CollectionReferenceIcon = icons__CollectionReferenceIcon_svg.SvgCollectionReferenceIcon;
exports.ColorIcon = icons__ColorIcon_svg.SvgColorIcon;
exports.ColorNoneIcon = icons__ColorNoneIcon_svg.SvgColorNoneIcon;
exports.CompassIcon = icons__CompassIcon_svg.SvgCompassIcon;
exports.ComposeIcon = icons__ComposeIcon_svg.SvgComposeIcon;
exports.ConfettiIcon = icons__ConfettiIcon_svg.SvgConfettiIcon;
exports.ConnectIcon = icons__ConnectIcon_svg.SvgConnectIcon;
exports.ContentFilledIcon = icons__ContentFilledIcon_svg.SvgContentFilledIcon;
exports.ContentIcon = icons__ContentIcon_svg.SvgContentIcon;
exports.ContractFilledIcon = icons__ContractFilledIcon_svg.SvgContractFilledIcon;
exports.ContractIcon = icons__ContractIcon_svg.SvgContractIcon;
exports.CornerPillIcon = icons__CornerPillIcon_svg.SvgCornerPillIcon;
exports.CornerRoundIcon = icons__CornerRoundIcon_svg.SvgCornerRoundIcon;
exports.CornerSquareIcon = icons__CornerSquareIcon_svg.SvgCornerSquareIcon;
exports.CreditCardCancelIcon = icons__CreditCardCancelIcon_svg.SvgCreditCardCancelIcon;
exports.CreditCardIcon = icons__CreditCardIcon_svg.SvgCreditCardIcon;
exports.CreditCardPercentIcon = icons__CreditCardPercentIcon_svg.SvgCreditCardPercentIcon;
exports.CreditCardReaderChipIcon = icons__CreditCardReaderChipIcon_svg.SvgCreditCardReaderChipIcon;
exports.CreditCardReaderIcon = icons__CreditCardReaderIcon_svg.SvgCreditCardReaderIcon;
exports.CreditCardReaderTapIcon = icons__CreditCardReaderTapIcon_svg.SvgCreditCardReaderTapIcon;
exports.CreditCardSecureIcon = icons__CreditCardSecureIcon_svg.SvgCreditCardSecureIcon;
exports.CreditCardTapChipIcon = icons__CreditCardTapChipIcon_svg.SvgCreditCardTapChipIcon;
exports.CropIcon = icons__CropIcon_svg.SvgCropIcon;
exports.CurrencyConvertIcon = icons__CurrencyConvertIcon_svg.SvgCurrencyConvertIcon;
exports.CursorBannerIcon = icons__CursorBannerIcon_svg.SvgCursorBannerIcon;
exports.CursorFilledIcon = icons__CursorFilledIcon_svg.SvgCursorFilledIcon;
exports.CursorIcon = icons__CursorIcon_svg.SvgCursorIcon;
exports.CursorOptionIcon = icons__CursorOptionIcon_svg.SvgCursorOptionIcon;
exports.DataPresentationIcon = icons__DataPresentationIcon_svg.SvgDataPresentationIcon;
exports.DataTableIcon = icons__DataTableIcon_svg.SvgDataTableIcon;
exports.DatabaseAddIcon = icons__DatabaseAddIcon_svg.SvgDatabaseAddIcon;
exports.DatabaseConnectIcon = icons__DatabaseConnectIcon_svg.SvgDatabaseConnectIcon;
exports.DatabaseIcon = icons__DatabaseIcon_svg.SvgDatabaseIcon;
exports.DeleteIcon = icons__DeleteIcon_svg.SvgDeleteIcon;
exports.DeliveryFilledIcon = icons__DeliveryFilledIcon_svg.SvgDeliveryFilledIcon;
exports.DeliveryIcon = icons__DeliveryIcon_svg.SvgDeliveryIcon;
exports.DesktopIcon = icons__DesktopIcon_svg.SvgDesktopIcon;
exports.DisabledIcon = icons__DisabledIcon_svg.SvgDisabledIcon;
exports.DiscountCodeIcon = icons__DiscountCodeIcon_svg.SvgDiscountCodeIcon;
exports.DiscountFilledIcon = icons__DiscountFilledIcon_svg.SvgDiscountFilledIcon;
exports.DiscountIcon = icons__DiscountIcon_svg.SvgDiscountIcon;
exports.DnsSettingsIcon = icons__DnsSettingsIcon_svg.SvgDnsSettingsIcon;
exports.DockFloatingIcon = icons__DockFloatingIcon_svg.SvgDockFloatingIcon;
exports.DockSideIcon = icons__DockSideIcon_svg.SvgDockSideIcon;
exports.DomainFilledIcon = icons__DomainFilledIcon_svg.SvgDomainFilledIcon;
exports.DomainIcon = icons__DomainIcon_svg.SvgDomainIcon;
exports.DomainLandingPageIcon = icons__DomainLandingPageIcon_svg.SvgDomainLandingPageIcon;
exports.DomainNewIcon = icons__DomainNewIcon_svg.SvgDomainNewIcon;
exports.DomainRedirectIcon = icons__DomainRedirectIcon_svg.SvgDomainRedirectIcon;
exports.DragDropIcon = icons__DragDropIcon_svg.SvgDragDropIcon;
exports.DragHandleIcon = icons__DragHandleIcon_svg.SvgDragHandleIcon;
exports.DuplicateIcon = icons__DuplicateIcon_svg.SvgDuplicateIcon;
exports.EditIcon = icons__EditIcon_svg.SvgEditIcon;
exports.EmailFollowUpIcon = icons__EmailFollowUpIcon_svg.SvgEmailFollowUpIcon;
exports.EmailIcon = icons__EmailIcon_svg.SvgEmailIcon;
exports.EmailNewsletterIcon = icons__EmailNewsletterIcon_svg.SvgEmailNewsletterIcon;
exports.EnterIcon = icons__EnterIcon_svg.SvgEnterIcon;
exports.EnvelopeIcon = icons__EnvelopeIcon_svg.SvgEnvelopeIcon;
exports.EnvelopeSoftPackIcon = icons__EnvelopeSoftPackIcon_svg.SvgEnvelopeSoftPackIcon;
exports.ExchangeIcon = icons__ExchangeIcon_svg.SvgExchangeIcon;
exports.ExitIcon = icons__ExitIcon_svg.SvgExitIcon;
exports.ExportIcon = icons__ExportIcon_svg.SvgExportIcon;
exports.ExternalIcon = icons__ExternalIcon_svg.SvgExternalIcon;
exports.ExternalSmallIcon = icons__ExternalSmallIcon_svg.SvgExternalSmallIcon;
exports.EyeCheckMarkIcon = icons__EyeCheckMarkIcon_svg.SvgEyeCheckMarkIcon;
exports.EyeDropperIcon = icons__EyeDropperIcon_svg.SvgEyeDropperIcon;
exports.EyeFirstIcon = icons__EyeFirstIcon_svg.SvgEyeFirstIcon;
exports.EyeglassesIcon = icons__EyeglassesIcon_svg.SvgEyeglassesIcon;
exports.FaviconIcon = icons__FaviconIcon_svg.SvgFaviconIcon;
exports.FileFilledIcon = icons__FileFilledIcon_svg.SvgFileFilledIcon;
exports.FileIcon = icons__FileIcon_svg.SvgFileIcon;
exports.FilterIcon = icons__FilterIcon_svg.SvgFilterIcon;
exports.FlagIcon = icons__FlagIcon_svg.SvgFlagIcon;
exports.FlipHorizontalIcon = icons__FlipHorizontalIcon_svg.SvgFlipHorizontalIcon;
exports.FlipVerticalIcon = icons__FlipVerticalIcon_svg.SvgFlipVerticalIcon;
exports.FlowerFilledIcon = icons__FlowerFilledIcon_svg.SvgFlowerFilledIcon;
exports.FlowerIcon = icons__FlowerIcon_svg.SvgFlowerIcon;
exports.FolderAddIcon = icons__FolderAddIcon_svg.SvgFolderAddIcon;
exports.FolderDownIcon = icons__FolderDownIcon_svg.SvgFolderDownIcon;
exports.FolderIcon = icons__FolderIcon_svg.SvgFolderIcon;
exports.FolderRemoveIcon = icons__FolderRemoveIcon_svg.SvgFolderRemoveIcon;
exports.FolderUpIcon = icons__FolderUpIcon_svg.SvgFolderUpIcon;
exports.FoodIcon = icons__FoodIcon_svg.SvgFoodIcon;
exports.ForkliftIcon = icons__ForkliftIcon_svg.SvgForkliftIcon;
exports.FormsIcon = icons__FormsIcon_svg.SvgFormsIcon;
exports.GamesIcon = icons__GamesIcon_svg.SvgGamesIcon;
exports.GaugeIcon = icons__GaugeIcon_svg.SvgGaugeIcon;
exports.GiftCardFilledIcon = icons__GiftCardFilledIcon_svg.SvgGiftCardFilledIcon;
exports.GiftCardIcon = icons__GiftCardIcon_svg.SvgGiftCardIcon;
exports.GlobeAsiaFilledIcon = icons__GlobeAsiaFilledIcon_svg.SvgGlobeAsiaFilledIcon;
exports.GlobeAsiaIcon = icons__GlobeAsiaIcon_svg.SvgGlobeAsiaIcon;
exports.GlobeEUFilledIcon = icons__GlobeEUFilledIcon_svg.SvgGlobeEuFilledIcon;
exports.GlobeEUIcon = icons__GlobeEUIcon_svg.SvgGlobeEuIcon;
exports.GlobeFilledIcon = icons__GlobeFilledIcon_svg.SvgGlobeFilledIcon;
exports.GlobeIcon = icons__GlobeIcon_svg.SvgGlobeIcon;
exports.HashtagDecimalIcon = icons__HashtagDecimalIcon_svg.SvgHashtagDecimalIcon;
exports.HashtagIcon = icons__HashtagIcon_svg.SvgHashtagIcon;
exports.HeartIcon = icons__HeartIcon_svg.SvgHeartIcon;
exports.HideIcon = icons__HideIcon_svg.SvgHideIcon;
exports.HomeFilledIcon = icons__HomeFilledIcon_svg.SvgHomeFilledIcon;
exports.HomeIcon = icons__HomeIcon_svg.SvgHomeIcon;
exports.IconsFilledIcon = icons__IconsFilledIcon_svg.SvgIconsFilledIcon;
exports.IconsIcon = icons__IconsIcon_svg.SvgIconsIcon;
exports.IdentityCardFilledIcon = icons__IdentityCardFilledIcon_svg.SvgIdentityCardFilledIcon;
exports.IdentityCardIcon = icons__IdentityCardIcon_svg.SvgIdentityCardIcon;
exports.ImageAddIcon = icons__ImageAddIcon_svg.SvgImageAddIcon;
exports.ImageAltIcon = icons__ImageAltIcon_svg.SvgImageAltIcon;
exports.ImageExploreIcon = icons__ImageExploreIcon_svg.SvgImageExploreIcon;
exports.ImageIcon = icons__ImageIcon_svg.SvgImageIcon;
exports.ImageMagicIcon = icons__ImageMagicIcon_svg.SvgImageMagicIcon;
exports.ImageWithTextOverlayIcon = icons__ImageWithTextOverlayIcon_svg.SvgImageWithTextOverlayIcon;
exports.ImagesIcon = icons__ImagesIcon_svg.SvgImagesIcon;
exports.ImportIcon = icons__ImportIcon_svg.SvgImportIcon;
exports.IncentiveIcon = icons__IncentiveIcon_svg.SvgIncentiveIcon;
exports.IncomingIcon = icons__IncomingIcon_svg.SvgIncomingIcon;
exports.InfoIcon = icons__InfoIcon_svg.SvgInfoIcon;
exports.InventoryFilledIcon = icons__InventoryFilledIcon_svg.SvgInventoryFilledIcon;
exports.InventoryIcon = icons__InventoryIcon_svg.SvgInventoryIcon;
exports.InventoryUpdatedIcon = icons__InventoryUpdatedIcon_svg.SvgInventoryUpdatedIcon;
exports.IqIcon = icons__IqIcon_svg.SvgIqIcon;
exports.KeyIcon = icons__KeyIcon_svg.SvgKeyIcon;
exports.KeyboardHideIcon = icons__KeyboardHideIcon_svg.SvgKeyboardHideIcon;
exports.KeyboardIcon = icons__KeyboardIcon_svg.SvgKeyboardIcon;
exports.LabelPrinterIcon = icons__LabelPrinterIcon_svg.SvgLabelPrinterIcon;
exports.LanguageFilledIcon = icons__LanguageFilledIcon_svg.SvgLanguageFilledIcon;
exports.LanguageIcon = icons__LanguageIcon_svg.SvgLanguageIcon;
exports.LanguageTranslateIcon = icons__LanguageTranslateIcon_svg.SvgLanguageTranslateIcon;
exports.LayoutBlockIcon = icons__LayoutBlockIcon_svg.SvgLayoutBlockIcon;
exports.LayoutBuyButtonHorizontalIcon = icons__LayoutBuyButtonHorizontalIcon_svg.SvgLayoutBuyButtonHorizontalIcon;
exports.LayoutBuyButtonIcon = icons__LayoutBuyButtonIcon_svg.SvgLayoutBuyButtonIcon;
exports.LayoutBuyButtonVerticalIcon = icons__LayoutBuyButtonVerticalIcon_svg.SvgLayoutBuyButtonVerticalIcon;
exports.LayoutColumn1Icon = icons__LayoutColumn1Icon_svg.SvgLayoutColumn1Icon;
exports.LayoutColumns2Icon = icons__LayoutColumns2Icon_svg.SvgLayoutColumns2Icon;
exports.LayoutColumns3Icon = icons__LayoutColumns3Icon_svg.SvgLayoutColumns3Icon;
exports.LayoutFooterIcon = icons__LayoutFooterIcon_svg.SvgLayoutFooterIcon;
exports.LayoutHeaderIcon = icons__LayoutHeaderIcon_svg.SvgLayoutHeaderIcon;
exports.LayoutLogoBlockIcon = icons__LayoutLogoBlockIcon_svg.SvgLayoutLogoBlockIcon;
exports.LayoutPopupIcon = icons__LayoutPopupIcon_svg.SvgLayoutPopupIcon;
exports.LayoutRows2Icon = icons__LayoutRows2Icon_svg.SvgLayoutRows2Icon;
exports.LayoutSectionIcon = icons__LayoutSectionIcon_svg.SvgLayoutSectionIcon;
exports.LayoutSidebarLeftIcon = icons__LayoutSidebarLeftIcon_svg.SvgLayoutSidebarLeftIcon;
exports.LayoutSidebarRightIcon = icons__LayoutSidebarRightIcon_svg.SvgLayoutSidebarRightIcon;
exports.LightbulbIcon = icons__LightbulbIcon_svg.SvgLightbulbIcon;
exports.LinkIcon = icons__LinkIcon_svg.SvgLinkIcon;
exports.ListBulletedFilledIcon = icons__ListBulletedFilledIcon_svg.SvgListBulletedFilledIcon;
exports.ListBulletedIcon = icons__ListBulletedIcon_svg.SvgListBulletedIcon;
exports.ListNumberedIcon = icons__ListNumberedIcon_svg.SvgListNumberedIcon;
exports.LiveFilledIcon = icons__LiveFilledIcon_svg.SvgLiveFilledIcon;
exports.LiveIcon = icons__LiveIcon_svg.SvgLiveIcon;
exports.LocationFilledIcon = icons__LocationFilledIcon_svg.SvgLocationFilledIcon;
exports.LocationIcon = icons__LocationIcon_svg.SvgLocationIcon;
exports.LocationNoneIcon = icons__LocationNoneIcon_svg.SvgLocationNoneIcon;
exports.LockFilledIcon = icons__LockFilledIcon_svg.SvgLockFilledIcon;
exports.LockIcon = icons__LockIcon_svg.SvgLockIcon;
exports.LogoCriteoIcon = icons__LogoCriteoIcon_svg.SvgLogoCriteoIcon;
exports.LogoFacebookIcon = icons__LogoFacebookIcon_svg.SvgLogoFacebookIcon;
exports.LogoGoogleIcon = icons__LogoGoogleIcon_svg.SvgLogoGoogleIcon;
exports.LogoInstagramIcon = icons__LogoInstagramIcon_svg.SvgLogoInstagramIcon;
exports.LogoMetaIcon = icons__LogoMetaIcon_svg.SvgLogoMetaIcon;
exports.LogoPinterestIcon = icons__LogoPinterestIcon_svg.SvgLogoPinterestIcon;
exports.LogoSnapchatIcon = icons__LogoSnapchatIcon_svg.SvgLogoSnapchatIcon;
exports.LogoTiktokIcon = icons__LogoTiktokIcon_svg.SvgLogoTiktokIcon;
exports.LogoTumblrIcon = icons__LogoTumblrIcon_svg.SvgLogoTumblrIcon;
exports.LogoTwitchIcon = icons__LogoTwitchIcon_svg.SvgLogoTwitchIcon;
exports.LogoVimeoIcon = icons__LogoVimeoIcon_svg.SvgLogoVimeoIcon;
exports.LogoXIcon = icons__LogoXIcon_svg.SvgLogoXIcon;
exports.LogoYoutubeIcon = icons__LogoYoutubeIcon_svg.SvgLogoYoutubeIcon;
exports.MagicIcon = icons__MagicIcon_svg.SvgMagicIcon;
exports.MarketsEuroFilledIcon = icons__MarketsEuroFilledIcon_svg.SvgMarketsEuroFilledIcon;
exports.MarketsEuroIcon = icons__MarketsEuroIcon_svg.SvgMarketsEuroIcon;
exports.MarketsFilledIcon = icons__MarketsFilledIcon_svg.SvgMarketsFilledIcon;
exports.MarketsIcon = icons__MarketsIcon_svg.SvgMarketsIcon;
exports.MarketsRupeeFilledIcon = icons__MarketsRupeeFilledIcon_svg.SvgMarketsRupeeFilledIcon;
exports.MarketsRupeeIcon = icons__MarketsRupeeIcon_svg.SvgMarketsRupeeIcon;
exports.MarketsYenFilledIcon = icons__MarketsYenFilledIcon_svg.SvgMarketsYenFilledIcon;
exports.MarketsYenIcon = icons__MarketsYenIcon_svg.SvgMarketsYenIcon;
exports.MaximizeIcon = icons__MaximizeIcon_svg.SvgMaximizeIcon;
exports.MeasurementSizeIcon = icons__MeasurementSizeIcon_svg.SvgMeasurementSizeIcon;
exports.MeasurementVolumeIcon = icons__MeasurementVolumeIcon_svg.SvgMeasurementVolumeIcon;
exports.MeasurementWeightIcon = icons__MeasurementWeightIcon_svg.SvgMeasurementWeightIcon;
exports.MediaReceiverIcon = icons__MediaReceiverIcon_svg.SvgMediaReceiverIcon;
exports.MegaphoneFilledIcon = icons__MegaphoneFilledIcon_svg.SvgMegaphoneFilledIcon;
exports.MegaphoneIcon = icons__MegaphoneIcon_svg.SvgMegaphoneIcon;
exports.MentionIcon = icons__MentionIcon_svg.SvgMentionIcon;
exports.MenuHorizontalIcon = icons__MenuHorizontalIcon_svg.SvgMenuHorizontalIcon;
exports.MenuIcon = icons__MenuIcon_svg.SvgMenuIcon;
exports.MenuVerticalIcon = icons__MenuVerticalIcon_svg.SvgMenuVerticalIcon;
exports.MergeIcon = icons__MergeIcon_svg.SvgMergeIcon;
exports.MetafieldsFilledIcon = icons__MetafieldsFilledIcon_svg.SvgMetafieldsFilledIcon;
exports.MetafieldsIcon = icons__MetafieldsIcon_svg.SvgMetafieldsIcon;
exports.MetaobjectFilledIcon = icons__MetaobjectFilledIcon_svg.SvgMetaobjectFilledIcon;
exports.MetaobjectIcon = icons__MetaobjectIcon_svg.SvgMetaobjectIcon;
exports.MetaobjectListIcon = icons__MetaobjectListIcon_svg.SvgMetaobjectListIcon;
exports.MetaobjectReferenceIcon = icons__MetaobjectReferenceIcon_svg.SvgMetaobjectReferenceIcon;
exports.MicrophoneIcon = icons__MicrophoneIcon_svg.SvgMicrophoneIcon;
exports.MinimizeIcon = icons__MinimizeIcon_svg.SvgMinimizeIcon;
exports.MinusCircleIcon = icons__MinusCircleIcon_svg.SvgMinusCircleIcon;
exports.MinusIcon = icons__MinusIcon_svg.SvgMinusIcon;
exports.MobileIcon = icons__MobileIcon_svg.SvgMobileIcon;
exports.MoneyFilledIcon = icons__MoneyFilledIcon_svg.SvgMoneyFilledIcon;
exports.MoneyIcon = icons__MoneyIcon_svg.SvgMoneyIcon;
exports.MoneyNoneIcon = icons__MoneyNoneIcon_svg.SvgMoneyNoneIcon;
exports.MoonIcon = icons__MoonIcon_svg.SvgMoonIcon;
exports.NatureIcon = icons__NatureIcon_svg.SvgNatureIcon;
exports.NoteAddIcon = icons__NoteAddIcon_svg.SvgNoteAddIcon;
exports.NoteIcon = icons__NoteIcon_svg.SvgNoteIcon;
exports.NotificationFilledIcon = icons__NotificationFilledIcon_svg.SvgNotificationFilledIcon;
exports.NotificationIcon = icons__NotificationIcon_svg.SvgNotificationIcon;
exports.OrderDraftFilledIcon = icons__OrderDraftFilledIcon_svg.SvgOrderDraftFilledIcon;
exports.OrderDraftIcon = icons__OrderDraftIcon_svg.SvgOrderDraftIcon;
exports.OrderFilledIcon = icons__OrderFilledIcon_svg.SvgOrderFilledIcon;
exports.OrderFirstIcon = icons__OrderFirstIcon_svg.SvgOrderFirstIcon;
exports.OrderFulfilledIcon = icons__OrderFulfilledIcon_svg.SvgOrderFulfilledIcon;
exports.OrderIcon = icons__OrderIcon_svg.SvgOrderIcon;
exports.OrderRepeatIcon = icons__OrderRepeatIcon_svg.SvgOrderRepeatIcon;
exports.OrderUnfulfilledIcon = icons__OrderUnfulfilledIcon_svg.SvgOrderUnfulfilledIcon;
exports.OrdersStatusIcon = icons__OrdersStatusIcon_svg.SvgOrdersStatusIcon;
exports.OrganizationIcon = icons__OrganizationIcon_svg.SvgOrganizationIcon;
exports.OutdentIcon = icons__OutdentIcon_svg.SvgOutdentIcon;
exports.OutgoingIcon = icons__OutgoingIcon_svg.SvgOutgoingIcon;
exports.PackageFilledIcon = icons__PackageFilledIcon_svg.SvgPackageFilledIcon;
exports.PackageFulfilledIcon = icons__PackageFulfilledIcon_svg.SvgPackageFulfilledIcon;
exports.PackageIcon = icons__PackageIcon_svg.SvgPackageIcon;
exports.PackageOnHoldIcon = icons__PackageOnHoldIcon_svg.SvgPackageOnHoldIcon;
exports.PackageReturnedIcon = icons__PackageReturnedIcon_svg.SvgPackageReturnedIcon;
exports.PageAddIcon = icons__PageAddIcon_svg.SvgPageAddIcon;
exports.PageAttachmentIcon = icons__PageAttachmentIcon_svg.SvgPageAttachmentIcon;
exports.PageClockFilledIcon = icons__PageClockFilledIcon_svg.SvgPageClockFilledIcon;
exports.PageClockIcon = icons__PageClockIcon_svg.SvgPageClockIcon;
exports.PageDownIcon = icons__PageDownIcon_svg.SvgPageDownIcon;
exports.PageHeartIcon = icons__PageHeartIcon_svg.SvgPageHeartIcon;
exports.PageIcon = icons__PageIcon_svg.SvgPageIcon;
exports.PageReferenceIcon = icons__PageReferenceIcon_svg.SvgPageReferenceIcon;
exports.PageRemoveIcon = icons__PageRemoveIcon_svg.SvgPageRemoveIcon;
exports.PageUpIcon = icons__PageUpIcon_svg.SvgPageUpIcon;
exports.PaginationEndIcon = icons__PaginationEndIcon_svg.SvgPaginationEndIcon;
exports.PaginationStartIcon = icons__PaginationStartIcon_svg.SvgPaginationStartIcon;
exports.PaintBrushFlatIcon = icons__PaintBrushFlatIcon_svg.SvgPaintBrushFlatIcon;
exports.PaintBrushRoundIcon = icons__PaintBrushRoundIcon_svg.SvgPaintBrushRoundIcon;
exports.PaperCheckIcon = icons__PaperCheckIcon_svg.SvgPaperCheckIcon;
exports.PasskeyFilledIcon = icons__PasskeyFilledIcon_svg.SvgPasskeyFilledIcon;
exports.PasskeyIcon = icons__PasskeyIcon_svg.SvgPasskeyIcon;
exports.PauseCircleIcon = icons__PauseCircleIcon_svg.SvgPauseCircleIcon;
exports.PaymentCaptureIcon = icons__PaymentCaptureIcon_svg.SvgPaymentCaptureIcon;
exports.PaymentFilledIcon = icons__PaymentFilledIcon_svg.SvgPaymentFilledIcon;
exports.PaymentIcon = icons__PaymentIcon_svg.SvgPaymentIcon;
exports.PersonAddIcon = icons__PersonAddIcon_svg.SvgPersonAddIcon;
exports.PersonExitIcon = icons__PersonExitIcon_svg.SvgPersonExitIcon;
exports.PersonFilledIcon = icons__PersonFilledIcon_svg.SvgPersonFilledIcon;
exports.PersonIcon = icons__PersonIcon_svg.SvgPersonIcon;
exports.PersonLockFilledIcon = icons__PersonLockFilledIcon_svg.SvgPersonLockFilledIcon;
exports.PersonLockIcon = icons__PersonLockIcon_svg.SvgPersonLockIcon;
exports.PersonRemoveIcon = icons__PersonRemoveIcon_svg.SvgPersonRemoveIcon;
exports.PersonSegmentIcon = icons__PersonSegmentIcon_svg.SvgPersonSegmentIcon;
exports.PersonalizedTextIcon = icons__PersonalizedTextIcon_svg.SvgPersonalizedTextIcon;
exports.PhoneIcon = icons__PhoneIcon_svg.SvgPhoneIcon;
exports.PhoneInIcon = icons__PhoneInIcon_svg.SvgPhoneInIcon;
exports.PhoneOutIcon = icons__PhoneOutIcon_svg.SvgPhoneOutIcon;
exports.PinFilledIcon = icons__PinFilledIcon_svg.SvgPinFilledIcon;
exports.PinIcon = icons__PinIcon_svg.SvgPinIcon;
exports.PlanFilledIcon = icons__PlanFilledIcon_svg.SvgPlanFilledIcon;
exports.PlanIcon = icons__PlanIcon_svg.SvgPlanIcon;
exports.PlayCircleIcon = icons__PlayCircleIcon_svg.SvgPlayCircleIcon;
exports.PlayIcon = icons__PlayIcon_svg.SvgPlayIcon;
exports.PlusCircleIcon = icons__PlusCircleIcon_svg.SvgPlusCircleIcon;
exports.PlusIcon = icons__PlusIcon_svg.SvgPlusIcon;
exports.PointOfSaleIcon = icons__PointOfSaleIcon_svg.SvgPointOfSaleIcon;
exports.PriceListFilledIcon = icons__PriceListFilledIcon_svg.SvgPriceListFilledIcon;
exports.PriceListIcon = icons__PriceListIcon_svg.SvgPriceListIcon;
exports.PrintIcon = icons__PrintIcon_svg.SvgPrintIcon;
exports.ProductAddIcon = icons__ProductAddIcon_svg.SvgProductAddIcon;
exports.ProductCostIcon = icons__ProductCostIcon_svg.SvgProductCostIcon;
exports.ProductFilledIcon = icons__ProductFilledIcon_svg.SvgProductFilledIcon;
exports.ProductIcon = icons__ProductIcon_svg.SvgProductIcon;
exports.ProductListIcon = icons__ProductListIcon_svg.SvgProductListIcon;
exports.ProductReferenceIcon = icons__ProductReferenceIcon_svg.SvgProductReferenceIcon;
exports.ProductRemoveIcon = icons__ProductRemoveIcon_svg.SvgProductRemoveIcon;
exports.ProductReturnIcon = icons__ProductReturnIcon_svg.SvgProductReturnIcon;
exports.ProfileIcon = icons__ProfileIcon_svg.SvgProfileIcon;
exports.QuestionCircleIcon = icons__QuestionCircleIcon_svg.SvgQuestionCircleIcon;
exports.ReceiptDollarFilledIcon = icons__ReceiptDollarFilledIcon_svg.SvgReceiptDollarFilledIcon;
exports.ReceiptDollarIcon = icons__ReceiptDollarIcon_svg.SvgReceiptDollarIcon;
exports.ReceiptEuroFilledIcon = icons__ReceiptEuroFilledIcon_svg.SvgReceiptEuroFilledIcon;
exports.ReceiptEuroIcon = icons__ReceiptEuroIcon_svg.SvgReceiptEuroIcon;
exports.ReceiptIcon = icons__ReceiptIcon_svg.SvgReceiptIcon;
exports.ReceiptPaidIcon = icons__ReceiptPaidIcon_svg.SvgReceiptPaidIcon;
exports.ReceiptPoundFilledIcon = icons__ReceiptPoundFilledIcon_svg.SvgReceiptPoundFilledIcon;
exports.ReceiptPoundIcon = icons__ReceiptPoundIcon_svg.SvgReceiptPoundIcon;
exports.ReceiptRefundIcon = icons__ReceiptRefundIcon_svg.SvgReceiptRefundIcon;
exports.ReceiptRupeeFilledIcon = icons__ReceiptRupeeFilledIcon_svg.SvgReceiptRupeeFilledIcon;
exports.ReceiptRupeeIcon = icons__ReceiptRupeeIcon_svg.SvgReceiptRupeeIcon;
exports.ReceiptYenFilledIcon = icons__ReceiptYenFilledIcon_svg.SvgReceiptYenFilledIcon;
exports.ReceiptYenIcon = icons__ReceiptYenIcon_svg.SvgReceiptYenIcon;
exports.RedoIcon = icons__RedoIcon_svg.SvgRedoIcon;
exports.ReferralCodeIcon = icons__ReferralCodeIcon_svg.SvgReferralCodeIcon;
exports.RefreshIcon = icons__RefreshIcon_svg.SvgRefreshIcon;
exports.RemoveBackgroundIcon = icons__RemoveBackgroundIcon_svg.SvgRemoveBackgroundIcon;
exports.ReplaceIcon = icons__ReplaceIcon_svg.SvgReplaceIcon;
exports.ReplayIcon = icons__ReplayIcon_svg.SvgReplayIcon;
exports.ResetIcon = icons__ResetIcon_svg.SvgResetIcon;
exports.ReturnIcon = icons__ReturnIcon_svg.SvgReturnIcon;
exports.RewardIcon = icons__RewardIcon_svg.SvgRewardIcon;
exports.RotateLeftIcon = icons__RotateLeftIcon_svg.SvgRotateLeftIcon;
exports.RotateRightIcon = icons__RotateRightIcon_svg.SvgRotateRightIcon;
exports.SandboxIcon = icons__SandboxIcon_svg.SvgSandboxIcon;
exports.SaveIcon = icons__SaveIcon_svg.SvgSaveIcon;
exports.SearchIcon = icons__SearchIcon_svg.SvgSearchIcon;
exports.SearchListIcon = icons__SearchListIcon_svg.SvgSearchListIcon;
exports.SearchRecentIcon = icons__SearchRecentIcon_svg.SvgSearchRecentIcon;
exports.SearchResourceIcon = icons__SearchResourceIcon_svg.SvgSearchResourceIcon;
exports.SelectIcon = icons__SelectIcon_svg.SvgSelectIcon;
exports.SendIcon = icons__SendIcon_svg.SvgSendIcon;
exports.SettingsFilledIcon = icons__SettingsFilledIcon_svg.SvgSettingsFilledIcon;
exports.SettingsIcon = icons__SettingsIcon_svg.SvgSettingsIcon;
exports.ShareIcon = icons__ShareIcon_svg.SvgShareIcon;
exports.ShieldCheckMarkIcon = icons__ShieldCheckMarkIcon_svg.SvgShieldCheckMarkIcon;
exports.ShieldNoneIcon = icons__ShieldNoneIcon_svg.SvgShieldNoneIcon;
exports.ShieldPendingIcon = icons__ShieldPendingIcon_svg.SvgShieldPendingIcon;
exports.ShieldPersonIcon = icons__ShieldPersonIcon_svg.SvgShieldPersonIcon;
exports.ShippingLabelFilledIcon = icons__ShippingLabelFilledIcon_svg.SvgShippingLabelFilledIcon;
exports.ShippingLabelIcon = icons__ShippingLabelIcon_svg.SvgShippingLabelIcon;
exports.ShopcodesIcon = icons__ShopcodesIcon_svg.SvgShopcodesIcon;
exports.SidekickIcon = icons__SidekickIcon_svg.SvgSidekickIcon;
exports.SkeletonIcon = icons__SkeletonIcon_svg.SvgSkeletonIcon;
exports.SlideshowIcon = icons__SlideshowIcon_svg.SvgSlideshowIcon;
exports.SmileyHappyIcon = icons__SmileyHappyIcon_svg.SvgSmileyHappyIcon;
exports.SmileyJoyIcon = icons__SmileyJoyIcon_svg.SvgSmileyJoyIcon;
exports.SmileyNeutralIcon = icons__SmileyNeutralIcon_svg.SvgSmileyNeutralIcon;
exports.SmileySadIcon = icons__SmileySadIcon_svg.SvgSmileySadIcon;
exports.SocialAdIcon = icons__SocialAdIcon_svg.SvgSocialAdIcon;
exports.SocialPostIcon = icons__SocialPostIcon_svg.SvgSocialPostIcon;
exports.SortAscendingIcon = icons__SortAscendingIcon_svg.SvgSortAscendingIcon;
exports.SortDescendingIcon = icons__SortDescendingIcon_svg.SvgSortDescendingIcon;
exports.SortIcon = icons__SortIcon_svg.SvgSortIcon;
exports.SoundIcon = icons__SoundIcon_svg.SvgSoundIcon;
exports.SportsIcon = icons__SportsIcon_svg.SvgSportsIcon;
exports.StarFilledIcon = icons__StarFilledIcon_svg.SvgStarFilledIcon;
exports.StarIcon = icons__StarIcon_svg.SvgStarIcon;
exports.StatusActiveIcon = icons__StatusActiveIcon_svg.SvgStatusActiveIcon;
exports.StatusIcon = icons__StatusIcon_svg.SvgStatusIcon;
exports.StopCircleIcon = icons__StopCircleIcon_svg.SvgStopCircleIcon;
exports.StoreFilledIcon = icons__StoreFilledIcon_svg.SvgStoreFilledIcon;
exports.StoreIcon = icons__StoreIcon_svg.SvgStoreIcon;
exports.StoreImportIcon = icons__StoreImportIcon_svg.SvgStoreImportIcon;
exports.StoreManagedIcon = icons__StoreManagedIcon_svg.SvgStoreManagedIcon;
exports.StoreOnlineIcon = icons__StoreOnlineIcon_svg.SvgStoreOnlineIcon;
exports.SunIcon = icons__SunIcon_svg.SvgSunIcon;
exports.TabletIcon = icons__TabletIcon_svg.SvgTabletIcon;
exports.TargetFilledIcon = icons__TargetFilledIcon_svg.SvgTargetFilledIcon;
exports.TargetIcon = icons__TargetIcon_svg.SvgTargetIcon;
exports.TaxFilledIcon = icons__TaxFilledIcon_svg.SvgTaxFilledIcon;
exports.TaxIcon = icons__TaxIcon_svg.SvgTaxIcon;
exports.TeamIcon = icons__TeamIcon_svg.SvgTeamIcon;
exports.TextAlignCenterIcon = icons__TextAlignCenterIcon_svg.SvgTextAlignCenterIcon;
exports.TextAlignLeftIcon = icons__TextAlignLeftIcon_svg.SvgTextAlignLeftIcon;
exports.TextAlignRightIcon = icons__TextAlignRightIcon_svg.SvgTextAlignRightIcon;
exports.TextBlockIcon = icons__TextBlockIcon_svg.SvgTextBlockIcon;
exports.TextBoldIcon = icons__TextBoldIcon_svg.SvgTextBoldIcon;
exports.TextColorIcon = icons__TextColorIcon_svg.SvgTextColorIcon;
exports.TextFontIcon = icons__TextFontIcon_svg.SvgTextFontIcon;
exports.TextFontListIcon = icons__TextFontListIcon_svg.SvgTextFontListIcon;
exports.TextGrammarIcon = icons__TextGrammarIcon_svg.SvgTextGrammarIcon;
exports.TextIcon = icons__TextIcon_svg.SvgTextIcon;
exports.TextInColumnsIcon = icons__TextInColumnsIcon_svg.SvgTextInColumnsIcon;
exports.TextInRowsFilledIcon = icons__TextInRowsFilledIcon_svg.SvgTextInRowsFilledIcon;
exports.TextInRowsIcon = icons__TextInRowsIcon_svg.SvgTextInRowsIcon;
exports.TextIndentIcon = icons__TextIndentIcon_svg.SvgTextIndentIcon;
exports.TextItalicIcon = icons__TextItalicIcon_svg.SvgTextItalicIcon;
exports.TextQuoteIcon = icons__TextQuoteIcon_svg.SvgTextQuoteIcon;
exports.TextTitleIcon = icons__TextTitleIcon_svg.SvgTextTitleIcon;
exports.TextUnderlineIcon = icons__TextUnderlineIcon_svg.SvgTextUnderlineIcon;
exports.TextWithImageIcon = icons__TextWithImageIcon_svg.SvgTextWithImageIcon;
exports.ThemeEditIcon = icons__ThemeEditIcon_svg.SvgThemeEditIcon;
exports.ThemeIcon = icons__ThemeIcon_svg.SvgThemeIcon;
exports.ThemeStoreIcon = icons__ThemeStoreIcon_svg.SvgThemeStoreIcon;
exports.ThemeTemplateIcon = icons__ThemeTemplateIcon_svg.SvgThemeTemplateIcon;
exports.ThumbsDownIcon = icons__ThumbsDownIcon_svg.SvgThumbsDownIcon;
exports.ThumbsUpIcon = icons__ThumbsUpIcon_svg.SvgThumbsUpIcon;
exports.TipJarIcon = icons__TipJarIcon_svg.SvgTipJarIcon;
exports.ToggleOffIcon = icons__ToggleOffIcon_svg.SvgToggleOffIcon;
exports.ToggleOnIcon = icons__ToggleOnIcon_svg.SvgToggleOnIcon;
exports.TransactionFeeDollarIcon = icons__TransactionFeeDollarIcon_svg.SvgTransactionFeeDollarIcon;
exports.TransactionFeeEuroIcon = icons__TransactionFeeEuroIcon_svg.SvgTransactionFeeEuroIcon;
exports.TransactionFeePoundIcon = icons__TransactionFeePoundIcon_svg.SvgTransactionFeePoundIcon;
exports.TransactionFeeRupeeIcon = icons__TransactionFeeRupeeIcon_svg.SvgTransactionFeeRupeeIcon;
exports.TransactionFeeYenIcon = icons__TransactionFeeYenIcon_svg.SvgTransactionFeeYenIcon;
exports.TransactionIcon = icons__TransactionIcon_svg.SvgTransactionIcon;
exports.TransferIcon = icons__TransferIcon_svg.SvgTransferIcon;
exports.TransferInIcon = icons__TransferInIcon_svg.SvgTransferInIcon;
exports.TransferInternalIcon = icons__TransferInternalIcon_svg.SvgTransferInternalIcon;
exports.TransferOutIcon = icons__TransferOutIcon_svg.SvgTransferOutIcon;
exports.UndoIcon = icons__UndoIcon_svg.SvgUndoIcon;
exports.UnknownDeviceIcon = icons__UnknownDeviceIcon_svg.SvgUnknownDeviceIcon;
exports.UploadIcon = icons__UploadIcon_svg.SvgUploadIcon;
exports.VariantIcon = icons__VariantIcon_svg.SvgVariantIcon;
exports.ViewIcon = icons__ViewIcon_svg.SvgViewIcon;
exports.ViewportNarrowIcon = icons__ViewportNarrowIcon_svg.SvgViewportNarrowIcon;
exports.ViewportShortIcon = icons__ViewportShortIcon_svg.SvgViewportShortIcon;
exports.ViewportTallIcon = icons__ViewportTallIcon_svg.SvgViewportTallIcon;
exports.ViewportWideIcon = icons__ViewportWideIcon_svg.SvgViewportWideIcon;
exports.WalletFilledIcon = icons__WalletFilledIcon_svg.SvgWalletFilledIcon;
exports.WalletIcon = icons__WalletIcon_svg.SvgWalletIcon;
exports.WandIcon = icons__WandIcon_svg.SvgWandIcon;
exports.WatchIcon = icons__WatchIcon_svg.SvgWatchIcon;
exports.WifiIcon = icons__WifiIcon_svg.SvgWifiIcon;
exports.WorkFilledIcon = icons__WorkFilledIcon_svg.SvgWorkFilledIcon;
exports.WorkIcon = icons__WorkIcon_svg.SvgWorkIcon;
exports.WrenchIcon = icons__WrenchIcon_svg.SvgWrenchIcon;
exports.XCircleIcon = icons__XCircleIcon_svg.SvgXCircleIcon;
exports.XIcon = icons__XIcon_svg.SvgXIcon;
exports.XSmallIcon = icons__XSmallIcon_svg.SvgXSmallIcon;
